module.exports = __webpack_public_path__ + "img/sofia_schmid_9.3d04c49c.jpg";